var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exporo-gallery-root"},[(null !== _vm.index)?_c('Lightbox',{ref:"lightbox",attrs:{"id":"mylightbox","images":_vm.images,"directory":_vm.base,"timeoutDuration":5000}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }